<template>
  <section class="erro">
    <div class="container">
      <div class="box">
        <div class="row">
          <div class="col-12">
            <div class="num-erro d-flex align-items-center justify-content-center">
              <i class="fas fa-exclamation-triangle mr-2"></i>
              <p>500</p>
            </div>
          </div>
          <div class="col-12 col-md-6 text-center">
            <img :src="require('@/assets/img/source.gif')" alt="Erro 404" class="img-fluid mb-3" />
          </div>
          <div class="col-12 col-md-6 text-center text-md-left erro-msg">
            <p>Ops!</p>
            <p>Seu paciente teve alta!</p>
            <p>A página que você estava acessando apresentou algum erro. Por favor clique em voltar abaixo para tentar novamente</p>
            <div class="d-flex align-items-center justify-content-center">
              <a class="btn btn-primary" :href="redirectTo">
                Voltar
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ErrorView',
  data () {
    return {
      redirectTo: '/home'
    }
  },
  mounted () {
    document.body.style.paddingBottom = '0px'
    if (this.$route.query.redir) {
      this.redirectTo = this.$route.query.redir
    }
  }
}
</script>

<style scoped>

</style>
